import moment from 'moment';

import isNil from 'lodash/isNil';

import {
  momentToTenMinuteFloorMoment
} from 'zoomforth_zfutils/datetime_formatting.js';

import {
  switchoverMoment as OLD_ANALYTICS_END_DATE
} from 'zoomforth_shared_management/lib/analytics_data_switchover.js';

export const DEFAULT_SORT_AND_SEARCH_PARAMS = {
  sortBy: 'timestamp',
  sortDir: 'desc',
  searchQuery: null
};

/**
 * Generate a composite object of filter settings. The primary purpose of this
 * function is to build the correct start and end dates.
 *
 * The goal with start date is to get to the point where we are showing the
 * last month's statistics. if the account is newer than that however then we
 * use the account creation date. our date range library also expects the
 * start and end dates to be different so we may need to adjust it further.
 */
export const getDefaultFilterSettings = (createdAt, defaultFilterSettings={})=> {
  if (isNil(createdAt)) {
    return {
      ...defaultFilterSettings,
      startDate: moment().subtract(1, 'day'),
      endDate: moment(),
      minDate: moment().subtract(1, 'day'),
      maxDate: moment()
    };
  }

  const creationDate = moment(Math.max(
    moment(createdAt),
    OLD_ANALYTICS_END_DATE
  ));

  const sixMonthsAgo = moment().subtract(6, 'month');

  const startDate = (
    sixMonthsAgo.isBefore(creationDate) ?
      creationDate
    :
      sixMonthsAgo
  );

  const endDate =  momentToTenMinuteFloorMoment(moment());

  if (startDate.isSame(endDate, 'day')) {
    startDate.subtract(1, 'day');
  }

  return {
    ...defaultFilterSettings,
    startDate,
    endDate,
    minDate: creationDate,
    maxDate: endDate
  };
};
